import { render, staticRenderFns } from "./Ezui.vue?vue&type=template&id=84ef6204"
import script from "./Ezui.vue?vue&type=script&lang=js"
export * from "./Ezui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports